const prepareContainerForSampleCopy = (container, containerNumber) => ({
  sampleName: null,
  tests: null,
  containerNumber,
  containerTypeName: container.containerTypeName ?? "",
  containerType: container.containerType ?? null,
  containerStatusName: "",
  containerStatus: { name: "Confirmed" },
  cylinderSerialNumber: null,
  size: container.size ?? "",
  containerSizeUoM: container.containerSizeUoM ?? "",
  uom: container.uom ?? null,
  tareWeight: null,
  tareWeightUoM: null,
  currentAmount: container.currentAmount ?? "",
  ownerEmail: container.ownerEmail ?? null,
  createdDate: null,
  createdByEmail: null,
  lastModifiedDate: null,
  lastModifiedByEmail: null,
  subLocation: container.subLocation ?? null,
  expirationDate: null,
  nextDispositionDate: null,
  discardOnDisposition: false,
  locationName: container.locationName ?? "",
  location: container.location ?? null,
  parentID: null,
  parentContainer: null,
  returnLocationName: "",
  returnLocation: null,
  sample: null,
  testsBackloggedOrPending: null,
  testsInProgress: null,
  changeLogs: null,
  distillationCuts: null,
  comments: null,
});

export const prepareSampleCopy = (sample, includeContainers = false) => {
  const copy = structuredClone(sample);
  const sourceContainers = Array.isArray(copy.containers) ? copy.containers : [];

  return {
    ...copy,
    sampleName: "NEW",
    containers: includeContainers
      ? sourceContainers.map((container, index) =>
          prepareContainerForSampleCopy(container, index),
        )
      : [],
    fileAttachments: [],
  };
};

export const getSampleCopyRouteState = (sample, includeContainers = false) => ({
  sampleObject: prepareSampleCopy(sample, includeContainers),
  draftSamples: [],
  draftObject: null,
});